<template>

    <button 
        v-if="type == 'button' || type == 'submit'" 
        :type="type"
        :class="getButtonClass()"
        @click="handleClick"
    >
        <slot />
    </button>

</template>

<script setup>
import { useSmartRouter } from '@jinkosoft/smart-router'
import { useRoute } from 'vue-router'
import { entityRouteForDefinition } from '@/router/appEntityRouting.js'

const emit = defineEmits(['click'])

const props = defineProps({
    to: [String, Object],
    preventScroll: Boolean,
    type: {
        type: String,
        default: 'button'
    }
})

const { push } = useSmartRouter()
const route = useRoute()

const handleClick = (event) => {
    event.preventDefault()
    
    push(entityRouteForDefinition(props.to, route.meta?.appEntityDefinition), props.preventScroll)

    emit('click', event)
}

const getButtonClass        = () => {

    let classes     = []

    classes.push(props.class)

    classes.push('j-btn-primary')

    return classes;
}
</script>